import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, ObjectiveFlag } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'

class StrengthHandTemplate extends React.Component {

    render() {

        return (
            <>
                <PatientCareCenterNoteSection id='str_hand' name='Hand and Wrist Template' level={2}>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand3_column}>
                            MC
                        </div>
                        <div className={styles.hand3_column_shaded}>
                            PIP
                        </div>
                        <div className={styles.hand3_column}>
                            DIP
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand6_column}>
                            R
                        </div>
                        <div className={styles.hand6_column}>
                            L
                        </div>
                        <div className={styles.hand6_column_shaded}>
                            R
                        </div>
                        <div className={styles.hand6_column_shaded}>
                            L
                        </div>
                        <div className={styles.hand6_column}>
                            R
                        </div>
                        <div className={styles.hand6_column}>
                            L
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle}></div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            Ext
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            Flex
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            Ext
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                        <div className={styles.hand12_column}>
                            Ext
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            Flex
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.index} mopno={this.props.mopno} flagText='Index Finger - Strength' />
                        <div className={styles.rowTitle}>
                            Index Finger
                        </div>
                        <div className={styles.hand12_column}>
                        <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='STNO'
                                entityKeyValue={this.props.stno}
                                field='STINDEXMCPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexMcpExtensionStrR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXMCPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                placeholder={this.props.prevIndexMcpFlexionStrR}
                                masterEntityDisplay='MSTNAME'
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXMCPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexMcpExtensionStrL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                placeholder={this.props.prevIndexMcpFlexionStrL}
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXMCPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXPIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexPipExtensionStrR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXPIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexPipFlexionStrR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXPIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexPipExtensionStrL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXPIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexPipFlexionStrL}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXDIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexDipExtensionStrR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXDIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexDipFlexionStrR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXDIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexDipExtensionStrL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STINDEXDIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevIndexDipFlexionStrL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.middle} mopno={this.props.mopno} flagText='Middle Finger - Strength' />
                        <div className={styles.rowTitle}>
                            Middle Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEMCPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleMcpeExtensionR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEMCPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleMcpFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEMCPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleMcpeExtensionL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEMCPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleMcpFlexionL}
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEPIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddlePipExtensionR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEPIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddlePipFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEPIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddlePipExtensionL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEPIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddlePipFlexionL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEDIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleDipExtensionR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEDIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleDipFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEDIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleDipExtensionL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STMIDDLEDIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevMiddleDipFlexionL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.ring} mopno={this.props.mopno} flagText='Ring Finger - Strength' />
                        <div className={styles.rowTitle}>
                            Ring Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGMCPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingMcpeExtensionR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGMCPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingMcpFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGMCPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingMcpeExtensionL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGMCPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingMcpFlexionL}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGPIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingPipExtensionR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGPIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                placeholder={this.props.prevRingPipFlexionR}
                                masterEntityDisplay='MSTNAME'
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGPIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingPipExtensionL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGPIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingPipFlexionL}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGDIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingDipExtensionR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGDIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingDipFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGDIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingDipExtensionL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STRINGDIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevRingDipFlexionL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.small} mopno={this.props.mopno} flagText='Small Finger - Strength' />
                        <div className={styles.rowTitle}>
                            Small Finger
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLMCPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallMcpeExtensionR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLMCPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallMcpeFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLMCPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallMcpeExtensionL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLMCPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                placeholder={this.props.prevSmallMcpeFlexionL}
                                masterEntityDisplay='MSTNAME'
                            />
                        </div>

                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLPIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallPipeExtensionR}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLPIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallPipFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLPIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallPipeExtensionL}
                            />
                        </div>
                        <label className={styles.slash_shaded}>/</label>
                        <div className={styles.hand12_column_shaded}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLPIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallPipFlexionL}
                            />
                        </div>

                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLDIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallDipExtensionR}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLDIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallDipFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLDIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallDipExtensionL}
                            />
                        </div>
                        <label className={styles.slash}>/</label>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STSMALLDIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevSmallDipFlexionL}
                            />
                        </div>
                    </div>
                    <div className={styles.rowSpacer}></div>
                    <div className={styles.row_hand}>
                    </div>
                    <div className={styles.row_hand}>
                        <div className={styles.flag}></div>
                        <div className={styles.rowTitle_large}></div>
                        <div className={styles.hand12_column}>
                            R
                        </div>

                        <div className={styles.hand12_column}>
                            L
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbMCPEx} mopno={this.props.mopno} flagText='Thumb - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb MCP Extension
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBMCPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbMcpeExtensionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBMCPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbMcpeExtensionL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbMCPFx} mopno={this.props.mopno} flagText='Thumb - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb MCP Flex
                        </div>

                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBMCPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbMcpFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBMCPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbMcpFlexionL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbIPEx} mopno={this.props.mopno} flagText='Thumb - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb IP Extension
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBIPEXTENSIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbIpExtensionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBIPEXTENSIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbIpExtensionL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbIPFx} mopno={this.props.mopno} flagText='Thumb - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb IP Flexion
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBIPFLEXIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbIpFlexionR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBIPFLEXIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbIpFlexionL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbAbd} mopno={this.props.mopno} flagText='Thumb Add/Abd - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb Abduction
                        </div>

                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBABDUCTIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbAbd}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBABDUCTIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbAdd}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.thumbAdd} mopno={this.props.mopno} flagText='Thumb Add/Abd - AROM' />
                        <div className={styles.rowTitle_large}>
                            Thumb Adduction
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBADDUCTIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbAddR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STTHUMBADDUCTIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevThumbAddL}
                            />
                        </div>
                    </div>
                    <div className={styles.row_hand}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.digitOpp} mopno={this.props.mopno} flagText='Thumb Add/Abd - AROM' />
                        <div className={styles.rowTitle_large}>
                            Digit Opposition
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STDIGITOPPOSITIONR'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevDigitOppR}
                            />
                        </div>
                        <div className={styles.hand12_column}>
                            <DBDropDownObjective
                                noteId={this.props.noteId}
                                entity='PTOBJECTIVESTR'
                                entityKeyColumn='stno'
                                entityKeyValue={this.props.stno}
                                field='STDIGITOPPOSITIONL'
                                className={styles.arom_hand}
                                masterEntity='PTMASTERSTRENGTH'
                                masterEntityKeyColumn='MSTNO'
                                masterEntitySort='MSTORDER'
                                masterEntityDisplay='MSTNAME'
                                placeholder={this.props.prevDigitOppL}
                            />
                        </div>
                    </div>

                </PatientCareCenterNoteSection >
            </>
        );
    }
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let index = false;
    let middle = false;
    let ring = false;
    let small = false;
    let thumb = false;
    let thumbMCPEx = false;
    let thumbMCPFx = false;
    let thumbIPEx = false;
    let thumbIPFx = false;
    let thumbAdd = false;
    let thumbAbd = false;
    let digitOpp = false;

    let flagValues = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

    //Index
    if ((state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXMCPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXPIPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STINDEXDIPFLEXIONL))) {
        index = true;
    }


    //Middle Finger
    if ((state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEMCPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEPIPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STMIDDLEDIPFLEXIONL))) {
        middle = true;
    }


    //Ring Finger
    if ((state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGMCPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGPIPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STRINGDIPFLEXIONL))) {
        ring = true;
    }


    //Small Finger
    if ((state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLMCPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLPIPFLEXIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPEXTENSIONL))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STSMALLDIPFLEXIONL))) {
        small = true;
    }

    //Thumb
    if ((state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPEXTENSIONL))) {
        thumbMCPEx = true;
    }

    if ((state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBMCPFLEXIONL))) {
        thumbMCPFx = true;
    }

    if ((state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPEXTENSIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPEXTENSIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPEXTENSIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPEXTENSIONL))) {
        thumbIPEx = true;
    }

    if ((state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPFLEXIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPFLEXIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPFLEXIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBIPFLEXIONL))) {
        thumbIPFx = true;
    }

    if ((state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBADDUCTIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBADDUCTIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBADDUCTIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBADDUCTIONL))) {
        thumbAdd = true;
    }

    if ((state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBABDUCTIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBABDUCTIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBABDUCTIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STTHUMBABDUCTIONL))) {
        thumbAbd = true;
    }

    if ((state.entities.notes.PTOBJECTIVESTR[stno].STDIGITOPPOSITIONR !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STDIGITOPPOSITIONR))
        || (state.entities.notes.PTOBJECTIVESTR[stno].STDIGITOPPOSITIONL !== null && flagValues.includes(state.entities.notes.PTOBJECTIVESTR[stno].STDIGITOPPOSITIONL))) {
        digitOpp = true;
    }

    let prevIndexMcpExtensionStrR = '';
    let prevIndexMcpFlexionStrR = '';
    let prevIndexMcpExtensionStrL = '';
    let prevIndexMcpFlexionStrL = '';
    let prevIndexPipExtensionStrR = '';
    let prevIndexPipFlexionStrR = '';
    let prevIndexPipExtensionStrL = '';
    let prevIndexPipFlexionStrL = '';
    let prevIndexDipExtensionStrR = '';
    let prevIndexDipFlexionStrR = '';
    let prevIndexDipExtensionStrL = '';
    let prevIndexDipFlexionStrL = '';

    let prevMiddleMcpeExtensionR = '';
    let prevMiddleMcpFlexionR = '';
    let prevMiddleMcpeExtensionL = '';
    let prevMiddleMcpFlexionL = '';
    let prevMiddlePipExtensionR = '';
    let prevMiddlePipFlexionR = '';
    let prevMiddlePipExtensionL = '';
    let prevMiddlePipFlexionL = '';
    let prevMiddleDipExtensionR = '';
    let prevMiddleDipFlexionR = '';
    let prevMiddleDipExtensionL = '';
    let prevMiddleDipFlexionL = '';

    let prevRingMcpeExtensionR = '';
    let prevRingMcpFlexionR = '';
    let prevRingMcpeExtensionL = '';
    let prevRingMcpFlexionL = '';
    let prevRingPipExtensionR = '';
    let prevRingPipFlexionR = '';
    let prevRingPipExtensionL = '';
    let prevRingPipFlexionL = '';
    let prevRingDipExtensionR = '';
    let prevRingDipFlexionR = '';
    let prevRingDipExtensionL = '';
    let prevRingDipFlexionL = '';

    let prevSmallMcpeExtensionR = '';
    let prevSmallMcpeFlexionR = '';
    let prevSmallMcpeExtensionL = '';
    let prevSmallMcpeFlexionL = '';
    let prevSmallPipeExtensionR = '';
    let prevSmallPipFlexionR = '';
    let prevSmallPipeExtensionL = '';
    let prevSmallPipFlexionL = '';
    let prevSmallDipExtensionR = '';
    let prevSmallDipFlexionR = '';
    let prevSmallDipExtensionL = '';
    let prevSmallDipFlexionL = '';
    let prevThumbMcpeExtensionR = '';
    let prevThumbMcpeExtensionL = '';
    let prevThumbMcpFlexionR = '';
    let prevThumbMcpFlexionL = '';
    let prevThumbIpExtensionR = '';
    let prevThumbIpExtensionL = '';
    let prevThumbIpFlexionR = '';
    let prevThumbIpFlexionL = '';
    let prevThumbAdd = '';
    let prevThumbAbd = '';
    let prevDigitOppL = '';
    let prevDigitOppR = '';
    let prevThumbAddR = '';
    let prevThumbAddL = '';

if (state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
    prevIndexMcpExtensionStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXMCPEXTENSIONR'];
    prevIndexMcpFlexionStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXMCPFLEXIONR'];
    prevIndexMcpExtensionStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXMCPEXTENSIONL'];
    prevIndexMcpFlexionStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXMCPFLEXIONL'];
    prevIndexPipExtensionStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXPIPEXTENSIONR'];
    prevIndexPipFlexionStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXPIPFLEXIONR'];
    prevIndexPipExtensionStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXPIPEXTENSIONL'];
    prevIndexPipFlexionStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXPIPFLEXIONL'];
    prevIndexDipExtensionStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXDIPEXTENSIONR'];
    prevIndexDipFlexionStrR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXDIPFLEXIONR'];
    prevIndexDipExtensionStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXDIPEXTENSIONL'];
    prevIndexDipFlexionStrL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STINDEXDIPFLEXIONL'];

    prevMiddleMcpeExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEMCPEXTENSIONR'];
    prevMiddleMcpFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEMCPFLEXIONR'];
    prevMiddleMcpeExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEMCPEXTENSIONL'];
    prevMiddleMcpFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEMCPFLEXIONL'];
    prevMiddlePipExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEPIPEXTENSIONR'];
    prevMiddlePipFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEPIPFLEXIONR'];
    prevMiddlePipExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEPIPEXTENSIONL'];
    prevMiddlePipFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEPIPFLEXIONL'];
    prevMiddleDipExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEDIPEXTENSIONR'];
    prevMiddleDipFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEDIPFLEXIONR'];
    prevMiddleDipExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEDIPEXTENSIONL'];
    prevMiddleDipFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STMIDDLEDIPFLEXIONL'];

    prevRingMcpeExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGMCPEXTENSIONR'];
    prevRingMcpFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGMCPFLEXIONR'];
    prevRingMcpeExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGMCPEXTENSIONL'];
    prevRingMcpFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGMCPFLEXIONL'];
    prevRingPipExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGPIPEXTENSIONR'];
    prevRingPipFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGPIPFLEXIONR'];
    prevRingPipExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGPIPEXTENSIONL'];
    prevRingPipFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGPIPFLEXIONL'];
    prevRingDipExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGDIPEXTENSIONR'];
    prevRingDipFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGDIPFLEXIONR'];
    prevRingDipExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGDIPEXTENSIONL'];
    prevRingDipFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STRINGDIPFLEXIONL'];

    prevSmallMcpeExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLMCPEXTENSIONR'];
    prevSmallMcpeFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLMCPFLEXIONR'];
    prevSmallMcpeExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLMCPEXTENSIONL'];
    prevSmallMcpeFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLMCPFLEXIONL'];
    prevSmallPipeExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLPIPEXTENSIONR'];
    prevSmallPipFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLPIPFLEXIONR'];
    prevSmallPipeExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLPIPEXTENSIONL'];
    prevSmallPipFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLPIPFLEXIONL'];
    prevSmallDipExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLDIPEXTENSIONR'];
    prevSmallDipFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLDIPFLEXIONR'];
    prevSmallDipExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLDIPEXTENSIONL'];
    prevSmallDipFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STSMALLDIPFLEXIONL'];
    
    prevThumbMcpeExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBMCPEXTENSIONR'];
    prevThumbMcpeExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBMCPEXTENSIONL'];
    prevThumbMcpFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBMCPFLEXIONR'];
    prevThumbMcpFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBMCPFLEXIONL'];
    prevThumbIpExtensionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBIPEXTENSIONR'];
    prevThumbIpExtensionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBIPEXTENSIONL'];
    prevThumbIpFlexionR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBIPFLEXIONR'];
    prevThumbIpFlexionL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBIPFLEXIONL'];
    prevThumbAdd = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBABDUCTIONL'];
    prevThumbAbd = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBABDUCTIONR'];

    prevThumbAddR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBADDUCTIONR'];
    prevThumbAddL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STTHUMBADDUCTIONL'];

    prevDigitOppL = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STDIGITOPPOSITIONL'];
    prevDigitOppR = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STDIGITOPPOSITIONR'];
}

    return {
        noteId: noteId,
        stno: stno,
        index,
        middle,
        ring,
        small,
        thumb,
        thumbAdd,
        thumbMCPEx,
        thumbMCPFx,
        thumbIPEx,
        thumbIPFx,
        thumbAdd,
        thumbAbd,
        digitOpp,
        prevIndexMcpExtensionStrR,
        prevIndexMcpFlexionStrR,
        prevIndexMcpExtensionStrL,
        prevIndexMcpFlexionStrL,
        prevIndexPipExtensionStrR,
        prevIndexPipFlexionStrR,
        prevIndexPipExtensionStrL,
        prevIndexPipFlexionStrL,
        prevIndexDipExtensionStrR,
        prevIndexDipFlexionStrR,
        prevIndexDipExtensionStrL,
        prevIndexDipFlexionStrL,
        prevMiddleMcpeExtensionR,
        prevMiddleMcpFlexionR,
        prevMiddleMcpeExtensionL,
        prevMiddleMcpFlexionL,
        prevMiddlePipExtensionR,
        prevMiddlePipFlexionR,
        prevMiddlePipExtensionL,
        prevMiddlePipFlexionL,
        prevMiddleDipExtensionR,
        prevMiddleDipFlexionR,
        prevMiddleDipExtensionL,
        prevMiddleDipFlexionL,
        prevRingMcpeExtensionR,
        prevRingMcpFlexionR,
        prevRingMcpeExtensionL,
        prevRingMcpFlexionL,
        prevRingPipExtensionR,
        prevRingPipFlexionR,
        prevRingPipExtensionL,
        prevRingPipFlexionL,
        prevRingDipExtensionR,
        prevRingDipFlexionR,
        prevRingDipExtensionL,
        prevRingDipFlexionL,
        prevSmallMcpeExtensionR,
        prevSmallMcpeFlexionR,
        prevSmallMcpeExtensionL,
        prevSmallMcpeFlexionL,
        prevSmallPipeExtensionR,
        prevSmallPipFlexionR,
        prevSmallPipeExtensionL,
        prevSmallPipFlexionL,
        prevSmallDipExtensionR,
        prevSmallDipFlexionR,
        prevSmallDipExtensionL,
        prevSmallDipFlexionL,
        prevThumbMcpeExtensionR,
        prevThumbMcpeExtensionL,
        prevThumbMcpFlexionR,
        prevThumbMcpFlexionL,
        prevThumbIpExtensionR,
        prevThumbIpExtensionL,
        prevThumbIpFlexionR,
        prevThumbIpFlexionL,
        prevThumbAdd,
        prevThumbAbd,
        prevDigitOppL,
        prevDigitOppR,
        prevThumbAddR,
        prevThumbAddL
    };
}

const connectedStrengthHandTemplate = connect(mapStateToProps)(StrengthHandTemplate);
export { connectedStrengthHandTemplate as StrengthHandTemplate };


